/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import IntegrationConnectionResolver from '../utils/IntegrationConnectionResolver';
import { SidePanelContext } from '../context/SidePanelContext';
import ShareToSlackPanel from './ShareToSlackPanel';
import ShareToSlackButton from './ShareToSlackButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ShareToSlack extends Component {
  constructor(props) {
    super(props);
    this.showPanel = () => this.setState({
      showPanel: true
    });
    this.hidePanel = () => this.setState({
      showPanel: false
    });
    this.state = {
      isIntegrationInstalled: false,
      showPanel: false
    };
  }
  static getDerivedStateFromProps(props) {
    if (props.isIntegrationInstalled !== undefined) {
      return {
        isIntegrationInstalled: props.isIntegrationInstalled
      };
    }
    return null;
  }
  componentDidMount() {
    const isIntegrationInstalled = this.props.isIntegrationInstalled;
    if (isIntegrationInstalled === undefined && !this.context) {
      IntegrationConnectionResolver.isConnected().then(status => this.setState({
        isIntegrationInstalled: status
      }));
    }
  }
  renderUsingSidePanelFromContextProvider() {
    return /*#__PURE__*/_jsx(SidePanelContext.Consumer, {
      children: ({
        showSidePanel
      }) => /*#__PURE__*/_jsx(ShareToSlackButton, {
        disabled: !this.props.recordToShare.id,
        showNewBadge: this.props.showNewBadge,
        showPanel: () => showSidePanel(this.props.description, this.props.recordToShare, this.props.placeIdentifier)
      })
    });
  }
  renderWithOwnSidePanel() {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(ShareToSlackButton, {
        disabled: !this.props.recordToShare.id,
        showNewBadge: this.props.showNewBadge,
        showPanel: this.showPanel
      }), this.state.showPanel && /*#__PURE__*/_jsx(ShareToSlackPanel, {
        recordToShare: this.props.recordToShare,
        closePanel: this.hidePanel,
        description: this.props.description,
        placeIdentifier: this.props.placeIdentifier
      })]
    });
  }
  render() {
    const installStatusPassedFromContext = this.context && this.context.isIntegrationInstalled;
    if (this.state.isIntegrationInstalled || installStatusPassedFromContext) {
      return this.context ? this.renderUsingSidePanelFromContextProvider() : this.renderWithOwnSidePanel();
    }
    return null;
  }
}
ShareToSlack.contextType = SidePanelContext;
ShareToSlack.propTypes = {
  recordToShare: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired,
  description: PropTypes.shape({
    header: PropTypes.string.isRequired,
    body: PropTypes.string
  }),
  placeIdentifier: PropTypes.string,
  isIntegrationInstalled: PropTypes.bool,
  showNewBadge: PropTypes.bool
};
export default ShareToSlack;